import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Tooltip from "@material-ui/core/Tooltip";
import {NavLink} from 'react-router-dom';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'
import Loader from '../../components/Loader'
import api from '../../api/Api'
import {dashboardRouter} from "../../util/globalHelper"
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import Place from "@material-ui/icons/Place";
import ArtTrack from "@material-ui/icons/ArtTrack";
import defaultAvatar from "assets/img/placeholder.jpg";
import Business from "@material-ui/icons/Business";

import SweetAlert from "react-bootstrap-sweetalert";

class readOneClinicMaster extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            clinicmaster_id: null,
            data: null,
            clinic_data: null,
            notFound: null,
            clickedId: "",
            redirect: false,
            alert: null,
            redirectAll: false,
            open: true,
            redirectAdd: false,
            redirectClinic: false,
            redirectOneClinic: false,
            redirectself: false,
            read: false,
            imagepreviewurl: defaultAvatar,
            selectedClinicId: ""
        };
        this.CreateAlert = this.CreateAlert.bind(this);
        this.ClinicCard = this.ClinicCard.bind(this);

    }

    componentDidMount() {
        this.callReadAPI(this.props.match.params.clinicmasterID)

    }

    callReadAPI(id) {
        api.getClinicMasterById(id).then(({data}) => {
            this.setState({data: data.data})
        }).catch(error => {
            this.setState({notFound: error})
        });
    }

    successDelete() {
        this.setState({
            alert: (
                <SweetAlert
                    success
                    style={{display: "block", marginTop: "-100px"}}
                    title="Deleted!"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }>
                </SweetAlert>
            )
        });
    }

    deleteRecord(id) {
        api.deleteClinicById(id)
            .then(json => {
            });

    }

    hideAlert() {
        this.setState({
            alert: null
        });
        window.location.reload()

    }

    CreateAlert(id) {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{display: "block", marginTop: "-100px"}}
                    title="Are you sure?"
                    onConfirm={() => {
                        this.successDelete();
                        this.deleteRecord(id)
                    }}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }
                    cancelBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.danger
                    }
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    You will not be able to recover this clinic!
                </SweetAlert>
            )
        });
    }

    renderClinicCard(stations) {
        return <GridContainer>
            {stations ? stations.map(function (station, i) {
                return <GridItem xs={12} sm={6} md={4} style={{display: 'flex'}} key={i}>
                    {[

                        <Card style={{}}>
                            <CardHeader image style={{textAlign: 'center'}}>
                                <a href="#pablo" onClick={e => e.preventDefault()}>
                                    <img src={station.images[0]} onError={(e) => {
                                        e.onerror = null;
                                        e.target.src = require('assets/img/placeholder.jpg')
                                    }}
                                         style={{maxWidth: '80%'}} alt=""/>
                                </a>
                            </CardHeader>
                            <CardBody>
                                <div>
                                    <Tooltip
                                        id="tooltip-top"
                                        title="View"
                                        placement="bottom"
                                    >
                                        <NavLink to={dashboardRouter("/read")}>
                                            <Button color="transparent" simple justIcon>
                                                <ArtTrack/>
                                            </Button>
                                        </NavLink>
                                    </Tooltip>
                                    <Tooltip
                                        id="tooltip-top"
                                        title="Edit"
                                        placement="bottom"
                                    > <NavLink to={dashboardRouter(`/update/${station._id}`)}>

                                        <Button color="success" simple justIcon>
                                            <Edit/>
                                        </Button></NavLink>
                                    </Tooltip>
                                    <Tooltip
                                        id="tooltip-top"
                                        title="Remove"
                                        placement="bottom"
                                    >
                                        <Button color="danger" simple justIcon
                                                onClick={() => this.CreateAlert(station._id)}>

                                            >
                                            <Delete/>
                                        </Button>
                                    </Tooltip>
                                </div>
                                <GridItem>
                                    <h4>
                                        <a href="#pablo" onClick={e => e.preventDefault()}>
                                            {station.name}
                                        </a>
                                    </h4>
                                    <div style={{maxHeight: 110}}>
                                        <TagsInput tagProps={{className: "react-tagsinput-tag info"}}
                                                   disabled
                                                   value={station.categories.map(function (obj) {
                                                       return obj.category;
                                                   })}
                                                   inputProps={{placeholder: ""}}/>
                                    </div>
                                    <p tyle={{color: 'black'}}>
                                        {station.description ? station.description : "No Description"}
                                    </p>
                                </GridItem>
                                <GridItem>
                                    <p style={{color: 'black'}}>
                                        <b>Contact: </b>{station.contact}
                                    </p>
                                    <p style={{color: 'black'}}>
                                        <b>Email:</b> {station.email}</p>
                                </GridItem>
                                <GridItem style={{color: 'black'}}>
                                    <Place/>
                                    <span>{station.address.locality !== "" ? station.address.locality : "N/A"}
                  </span>
                                </GridItem>
                            </CardBody>

                        </Card>

                    ]}
                </GridItem>;
            }) : null}
        </GridContainer>
    }

    ClinicCard(stations) {
        const {classes} = this.props;
        const globalThis = this;
        return (<GridContainer>
            {this.state.alert}
            {stations && this.state.data ? stations.map(function (station, i) {
                return <GridItem xs={12} sm={6} md={4} style={{display: 'flex'}} key={i}>
                    {[
                        <Card className={classes.cardHover} key={Math.random()}>
                            <CardHeader image className={classes.cardHeaderHover} style={{textAlign: 'center'}}>
                                <a href="#pablo" onClick={e => e.preventDefault()}>
                                    <img src={station.images[0]} onError={(e) => {
                                        e.onerror = null;
                                        e.target.src = require('assets/img/placeholder.jpg')
                                    }}
                                         style={{maxWidth: '80%'}} alt=""/>
                                </a>
                            </CardHeader>
                            <CardBody style={{textAlign: 'center'}}>
                                <div className={classes.cardHoverUnder}>
                                    <Tooltip
                                        id="tooltip-top"
                                        title="View"
                                        placement="bottom">
                                        <NavLink
                                            to={dashboardRouter(`/clinic/oneClinic/${station._id}`)}>
                                            <Button color="transparent" simple justIcon>
                                                <ArtTrack className={classes.underChartIcons}/>
                                            </Button>
                                        </NavLink>
                                    </Tooltip>
                                    <Tooltip
                                        id="tooltip-top"
                                        title="Edit"
                                        placement="bottom">
                                        <NavLink
                                            to={dashboardRouter(`/clinic/updateClinic/${station._id}`)}>

                                            <Button color="success" simple justIcon>
                                                <Edit/>
                                            </Button></NavLink>
                                    </Tooltip>
                                    <Tooltip
                                        id="tooltip-top"
                                        title="Remove"
                                        placement="bottom">
                                        <Button color="danger" simple
                                                justIcon onClick={() =>
                                            globalThis.CreateAlert(station._id)}>
                                            <Delete/>
                                        </Button>
                                    </Tooltip>
                                </div>
                                <GridItem>
                                    <h4>
                                        <a href="#pablo" onClick={e => e.preventDefault()}>
                                            {station.name}
                                        </a>
                                    </h4>
                                    <div style={{maxHeight: 110}}>
                                        <TagsInput tagProps={{className: "react-tagsinput-tag info"}}
                                                   disabled
                                                   value={station.categories.map(function (obj) {
                                                       return obj.category;
                                                   })}
                                                   inputProps={{placeholder: ""}}/>
                                    </div>
                                    {station.description ?
                                        <div style={{color: 'black'}}
                                             dangerouslySetInnerHTML={{__html: station.description}}/>
                                        : null}
                                </GridItem>
                                <GridItem>
                                    <p style={{color: 'black'}}>
                                        <b>Contact: </b>{station.contact}
                                    </p>
                                    <p style={{color: 'black'}}>
                                        <b>Email:</b> {station.email}</p>
                                </GridItem>
                                <GridItem style={{color: 'black'}}>
                                    <Place/>
                                    <span>{station.address.locality !== "" ? station.address.locality : "N/A"}
                  </span>
                                </GridItem>
                            </CardBody>

                        </Card>

                    ]}
                </GridItem>;
            }) : null}
        </GridContainer>)
    };

    render() {
        const {data} = this.state;
        if (this.state.data) {
            return (
                <div>
                    {this.state.alert}
                    <Card>
                        <CardHeader color="info" text>
                            <CardText color="info">
                                <h4>Clinic Master</h4>
                            </CardText>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12}>
                                    <h2 style={{margin: 20}}>{data.clinicmaster_name}</h2>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={8}>
                                    <div style={{margin: 20}}>
                                        <br></br>
                                        <h3><b>{data.clinicmaster_companynumber}</b></h3>
                                        <h4>Company Number</h4>
                                        <h3><b>{data.clinicmaster_adminname}</b></h3>
                                        <h4>Admin</h4>
                                        <h3><b>{data.clinicmaster_contactinfo}</b></h3>
                                        <h4>Contact Number</h4>
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={4} md={3} style={{marginTop: 50}}>
                                    <div>
                                        <NavLink
                                            to={dashboardRouter(`/clinicmaster/updateClinicMaster/${data.clinicmaster_id}`)}>
                                            <Button block size="lg" color="info">
                                                <Icon>border_color</Icon>
                                                <span style={{paddingLeft: 10}}>Update</span>
                                            </Button></NavLink>
                                        <br></br>

                                    </div>
                                    <br></br>

                                </GridItem>
                            </GridContainer>
                            {this.state.data.clinicmaster_clinics.length > 0 ? (

                                <GridItem>
                                    <GridContainer>
                                        <GridItem xs={12} sm={6} md={2}>
                                            <NavLink to={dashboardRouter(`/clinic/addClinic/${data.clinicmaster_id}`)}>
                                                <Button block size="lg" color="warning">
                                                    <Icon>add</Icon>
                                                    <span style={{paddingLeft: 10}}>ADD NEW</span>
                                                </Button>
                                            </NavLink>
                                        </GridItem>
                                    </GridContainer>
                                    <br></br><br></br><br></br><br></br>
                                    <GridContainer>
                                        <GridItem xs={12}>
                                            {this.ClinicCard(this.state.data.clinicmaster_clinics)}
                                            {/*<ClinicCard stations={ this.state.data.clinicmaster_clinics}/>*/}
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>) : (<Card>
                                <GridItem>
                                    <GridContainer className={""}
                                                   style={{justifyContent: 'center', textAlign: 'center'}}>
                                        <GridItem xs={12} style={{justifyContent: 'center'}}>
                                            <br/><br/>
                                            <Business style={{fontSize: 75}}/>

                                        </GridItem>
                                        <GridItem xs={12} style={{justifyContent: 'center'}}>
                                            <h3>No Clinics Found</h3>
                                        </GridItem>
                                        <GridItem xs={12} style={{justifyContent: 'center'}}>
                                            <h4>Looks like you have no clinics.<br/> Click on the button below to add a
                                                new
                                                clinic. <br/><br/>
                                            </h4>
                                        </GridItem>
                                        <GridItem xs={12} sm={4} md={3} style={{justifyContent: 'center'}}>
                                            <NavLink to={dashboardRouter(`/clinic/addClinic/${data.clinicmaster_id}`)}>
                                                <Button block size="lg" color="warning">
                                                    <Icon>add</Icon>
                                                    <span style={{paddingLeft: 10}}>ADD NEW</span>
                                                </Button>
                                            </NavLink>
                                            <br/><br/>
                                        </GridItem>
                                    </GridContainer>
                                    <br/><br/><br/>
                                </GridItem>
                            </Card>)}

                        </CardBody>
                    </Card>
                </div>
            );
        } else if (this.state.notFound !== null) {
            return <h2 className="text-center">Data Not Found</h2>
        } else return (<div>
            <Loader/>
        </div>);
    }
}

export default withStyles(dashboardStyle)(readOneClinicMaster)


// WEBPACK FOOTER //
// ./src/views/ClinicMasters/oneClinicMaster.jsx